<template>
  <div>
    <div class="table_td_title">
      <div :style="{ 'width': Phone?`25%`:`10%` }">
        {{ $t(`lang.str_hashbettype`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
        <div class="gameImgArea_5">
          <div class="box" v-for="(itemBase, indexBase) in [[1, 2], [2, 2], [3, 18], [4, 28], [5, 31], [6, 40], [7, 14], [8, 17], [9, 20], [10, 8], [11, 10], [12, 11], [13, 5], [14, 6], [15, 8]]" :key="indexBase"  >
            <div v-if="Number(new Map(Object.entries(winpos.BetsInfo).map(([key, value]) => [value.betPos, value.betAmount])).get(itemBase[0])) > 0">
              <div v-for="(item, index) in new Map(Object.entries(winpos.BetsInfo).map(([key, value]) => [value.betPos, value]))" :key="index">
                <div v-if="itemBase[0] == item[0]"  class="img_container" :style="{ 'background': `url(${require('../../assets/slwh/' + getSlwhBg(item[0]) + '.png')})`, 'background-size': '100% 100%' }">
                  <img style="height: 80%; width: 80%;" :src="require('../../assets/slwh/' + getSlwhIcon(item[0]) + '.png')" alt="" :class="{ deep: true }">
                </div>
                <div v-if="itemBase[0] == item[0]">
                  <p v-if="item[1].betAmount > 0">{{(parseFloat(item[1].betAmount).toFixed(2) / 100).toFixed(2)}} x {{itemBase[1]}}</p>
                  <p v-else class="gray_color"  >0 x {{itemBase[1]}}</p>
                  <p class="yellow_color" v-if="item[1].winAmount > 0">+{{(parseFloat(item[1].winAmount).toFixed(2) / 100).toFixed(2)}}</p>
                  <p v-else>-</p>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="img_container" :style="{'background': `url(${require('../../assets/slwh/' + getSlwhBg(itemBase[0]) + '.png')})`, 'background-size': '100% 100%' ,'opacity':0.3}">
                <img style="height: 80%; width: 80%;" :src="require('../../assets/slwh/' + getSlwhIcon(itemBase[0]) + '.png')" alt="" :class="{ deep: false }">
              </div>
              <p class="gray_color">0 x {{itemBase[1]}}</p>
              <p>-</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table_td_title">
      <div :style="{ 'width': Phone?`25%`:`10%`, 'vertical-align': 'center'}">
        {{ $t(`lang.str_hashresult`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
        <div class="gameImgArea_result">
          <div class="img_container" :style="{ 'background': `url(${require('../../assets/slwh/c' + winpos.HitColor + '.png')})`, 'background-size': '100% 100%' }">
            <img style="height: 80%; width: 80%;" :src="require('../../assets/slwh/' + winpos.HitAnimal + '.png')" alt="" :class="{ deep: true }">
          </div>
          <div class="img_container" :style="{ 'background': `url(${require('../../assets/slwh/czxh.png')})`, 'background-size': '100% 100%' }">
            <img style="height: 80%; width: 80%;" :src="require('../../assets/slwh/zxh_' + winpos.HitTradition + '.png')" alt="" :class="{ deep: true }">
          </div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content="describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3011",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    winpos:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    getSlwhIcon(index) {
      if(index <= 3) {
        if(this.getlang != 'zh_cn') {
          return "zxh_" + index + "_tw"
        } else {
          return "zxh_" + index
        }
      } else {
        return Math.floor((index - 1) / 3);
      }
    },
    getSlwhBg(index) {
      if(index <= 3) {
        return "czxh"
      } else {
        return "c" + (Math.floor((index - 1) % 3) + 1);
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3011.vue